import { Card, Typography } from '@mui/material';
import styled from 'styled-components';

const WelcomeName = styled.span`
  background: -webkit-linear-gradient(45deg,${({ theme }) => theme.palette.primary.main}, ${({ theme }) => theme.palette.info.main});
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const WelcomeText = styled(Typography)`
  && {
    font-weight: 300;
    margin-top: ${({ theme }) => theme.spacing(1)};
    color: ${({ theme }) => theme.palette.gray.dark};
  }
`;

const WelcomeTitle = styled(Typography)`
  && {
    font-weight: bold;
    color: ${({ theme }) => theme.palette.darkPrimary.dark};
  }
`;

const WelcomeCardContainer = styled(Card)`
  && {
    padding: ${({ theme }) => theme.spacing(6)};
    background-color: ${({ theme }) => theme.palette.backdrop.main};
    border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
    box-shadow: none;
  }
`;

export { WelcomeName, WelcomeText, WelcomeTitle, WelcomeCardContainer };
